import script from "./ToasterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToasterComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ToasterComponent.vue?vue&type=style&index=0&id=95bbf40a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95bbf40a"]])

export default __exports__